module.exports = __webpack_public_path__ + "static/img/pdf-upload.313c7276.svg";